<script setup lang="ts">
    import type { LookbookCollageData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    defineProps<IWidgetProps<LookbookCollageData>>();
</script>
<template>
    <mol-lookbook-collage
        :title="data.title"
        :copy="data.copy"
        :asset1="data.asset1"
        :asset2="data.asset2"
        :asset3="data.asset3"
        :link="data.link"
        :anchor="data.anchor"
        :style="data.style"
        :codename="data.codename"
        class="cms-lookbook-collage-widget" />
</template>
